/**
 * 将 Gateway WS auth_fail.reject_reason 转为运维可读文案（对齐游戏客户端）
 */
export function formatWsAuthFailMessage(reason: string): string {
  const map: Record<string, string> = {
    not_enrolled:
      '机台尚未报名：请到「KEYT 报名」复制本机 KEYT 与设备指纹，在管理后台完成报名后再连',
    machine_not_found: '机台码不存在：请核对运维页机台码是否与后台一致',
    machine_disabled: '机台已停用：请在管理后台启用后再连',
    machine_mode_mismatch: '机台运行模式不正确：请在后台将运行模式设为点数卡',
    sig_mismatch:
      'WS 签名不匹配：KEYT 与后台报名公钥不一致，请重置报名后重新粘贴 KEYT/指纹',
    ts_out_of_window: '本机时间与服务器偏差过大，请校准系统时间后重试',
    nonce_replayed: '鉴权请求被判定为重放，请稍后重试',
    missing_machine_code: '未配置机台码：请先在运维页填写并保存机台码',
    missing_params: 'WS 鉴权参数不完整，请重启客户端后重试',
    derive_failed: 'WS 验签异常，请联系技术排查服务端日志',
    secret_fetch_failed: '本机 KEYT 签名失败：请检查 KEYT 是否已生成，并重新报名',
    max_retries_exceeded:
      'WS 多次重连失败：请确认 Gateway :8282 可达，且地址未被 CSP 拦截（127.0.0.1 与 localhost 不同）',
  }
  return map[reason] || `WS 鉴权失败: ${reason}`
}

/** 后台报名完成后可自动恢复的拒绝原因（持续重连，对齐游戏客户端） */
export function isRecoverableWsAuthFail(reason: string): boolean {
  return reason === 'not_enrolled'
}
